import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { CommonService } from "src/app/core/services/common.service";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { MaintenanceHistoricoBastidorService } from "../maintenance-historico-bastidor.service";

@Component({
  selector: "app-maintenance-historico-bastidor-selected",
  templateUrl: "./maintenance-historico-bastidor-selected.component.html",
  styleUrls: ["./maintenance-historico-bastidor-selected.component.scss"],
})
export class MaintenanceHistoricoBastidorSelectedComponent implements OnInit {
  public filtersTable: string;
  filtersTableJSON;
  public filtersSearch = "";

  public maintenanceHistoricoBastidor;
  public operation: string;
  public routing = RoutingConstants.maintenanceHistoricoBastidor;
  numPages: number = 0;
  numElements: number = 0;
  totalElements: number = 0;

  lists = {
    hbListabastidores: [],
  };

  constructor(
    private maintenanceHistoricoBastidorService: MaintenanceHistoricoBastidorService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastrAlertService: ToastrAlertService,
    private filtersTableStateService: FiltersTableStateService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.initFormGroup();
    this.operation = this.activatedRoute.data["_value"]["operation"];

    if (this.operation === "edicion") {
      this.getBastidorInfo(this.activatedRoute.snapshot.params.id);
    }
  }

  initFormGroup() {
    const emailRegex =
      "^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$";
    this.maintenanceHistoricoBastidor = new FormGroup({
      hbBastidor: new FormControl("", [
        Validators.required,
        Validators.minLength(9),
        Validators.maxLength(128),
      ]),

      hbCodimag: new FormControl("", [Validators.maxLength(128)]),

      hbContrasena: new FormControl("", [
        Validators.required,
        Validators.maxLength(128),
      ]),

      hbTipo: new FormControl("", [
        Validators.required,
        Validators.maxLength(128),
      ]),

      hbVersion: new FormControl("", [Validators.maxLength(128)]),

      hbVariante: new FormControl("", [
        Validators.required,
        Validators.maxLength(128),
      ]),

      hbFechaalta: new FormControl("", [
        Validators.required,
        Validators.maxLength(128),
      ]),

      hbEmisionCo2: new FormControl("", [Validators.maxLength(128)]),

      hbMotor: new FormControl("", [Validators.maxLength(128)]),
      hbCambio: new FormControl("", [Validators.maxLength(128)]),
      hbCorrelativo: new FormControl("", [Validators.maxLength(128)]),
    });
  }

  createBastidorForSubmit(data) {
    let bastidor = {
      hbBastidor: data.hbBastidor,
      hbCodimag: data.hbCodimag,
      hbContrasena: data.hbContrasena,
      hbTipo: data.hbTipo,
      hbVariante: data.hbVariante,
      hbFechaalta: data.hbFechaalta,
      hbEmisionCo2: data.hbEmisionCo2,
      hbMotor: data.hbMotor,
      hbCambio: data.hbCambio,
      hbCorrelativo: data.hbCorrelativo,

      hbVersion: data.hbVersion,
      hbExtension: data.hbExtension,
      hbUsuario: data.hbUsuario,
    };

    return bastidor;
  }

  onSave() {
    let invalidFields = this.commonService.findInvalidControls(
      this.maintenanceHistoricoBastidor.controls
    );
    if (invalidFields.length > 0) {
      let text = this.commonService.getValueOfLabelsById(invalidFields);
      this.toastrAlertService.toastrFail(text);
    } else {
      if (this.operation === "edicion") {
        this.onEdit();
      } else if (this.operation === "creacion") {
        this.onCreate();
      }
    }
  }

  onEdit() {
    this.maintenanceHistoricoBastidorService
      .editBastidor(
        this.createBastidorForSubmit(this.maintenanceHistoricoBastidor.value),
        this.maintenanceHistoricoBastidor.value.hbBastidor
      )
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess("Bastidor editado");
          this.router.navigate([this.routing.list]);
        },
        (err) => {
          this.toastrAlertService.toastrFail(
            err.error.mensaje ? err.error.mensaje : "Error al guardar usuario"
          );
        }
      );
  }

  onCreate() {
    this.maintenanceHistoricoBastidorService
      .createBastidor(
        this.createBastidorForSubmit(this.maintenanceHistoricoBastidor.value)
      )
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess("Bastidor creado");
          this.router.navigate([this.routing.list]);
        },
        (err) => {
          this.toastrAlertService.toastrFail(
            err.error.mensaje ? err.error.mensaje : "Error al crear bastidor"
          );
        }
      );
  }

  getBastidorInfo(userId: string) {
    this.maintenanceHistoricoBastidorService.getBastidor(userId).subscribe(
      (data) => {
        this.setValues(data);
      },
      (err) => {
        this.toastrAlertService.toastrFail(
          err.error.mensaje ? err.error.mensaje : "Error al cargar usuario"
        );
      }
    );
  }

  setValues(data) {
    this.maintenanceHistoricoBastidor.patchValue({
      hbBastidor: data.hbBastidor,
      hbCodimag: data.hbCodimag,
      hbContrasena: data.hbContrasena,
      hbTipo: data.hbTipo,
      hbVersion: data.hbVersion,
      hbVariante: data.hbVariante,
      hbFechaalta: data.hbFechaalta,
      hbEmisionCo2: data.hbEmisionCo2,
      hbMotor: data.hbMotor,
      hbCambio: data.hbCambio,
      hbCorrelativo: data.hbCorrelativo,
    });
  }

  filterSearch(value: string) {
    this.filtersSearch = value;

    this.filtersSearch = value;
    this.filtersTableStateService.setPageState(0);
    this.filtersTableJSON =
      this.filtersTableStateService.getFiltersTableState();
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON
    );
  }

  filterTable(value: string) {
    this.filtersTable = value;
  }

  goList() {
    this.router.navigate([this.routing.list]);
  }

  updateTipo(e: Event) {
    this.maintenanceHistoricoBastidor.patchValue({
      hbTipo: this.maintenanceHistoricoBastidor.value.hbTipo,
    });
  }
}
